/**
 * Israeli mobile numbers for phone (SMS code) login.
 * Users type 050-1234567, 0501234567, +972 50 123 4567 …; the backend normalizes the same way.
 */

/** Local 10-digit form (0501234567) of whatever the user typed so far; drops +972 / 972. */
export function toLocalMobileDigits(value: string | null | undefined): string {
  let digits = String(value ?? '').replace(/\D/g, '');
  if (digits.startsWith('972')) {
    digits = '0' + digits.slice(3);
  } else if (digits.startsWith('5')) {
    digits = '0' + digits;
  }
  return digits.slice(0, 10);
}

export function isValidIsraeliMobile(value: string | null | undefined): boolean {
  return /^05\d{8}$/.test(toLocalMobileDigits(value));
}

/** 05X-XXXXXXX while typing (dash after the prefix only). */
export function formatIsraeliMobile(value: string | null | undefined): string {
  const digits = toLocalMobileDigits(value);
  return digits.length > 3 ? `${digits.slice(0, 3)}-${digits.slice(3)}` : digits;
}

/** Stored users.phone (501234567) → 050-1234567. */
export function formatStoredPhone(phone: number | string | null | undefined): string {
  return phone ? formatIsraeliMobile(String(phone)) : '';
}
